import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMasterLecture = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lectureList, setLectureList] = useState<any[]>();
  const [summary, setSummary] = useState<any[]>();
  const [gap, setGap] = useState<any>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const today = new Date();
  const default_start_date = today.getFullYear().toString() + '-01';
  const default_end_date = today.getFullYear().toString() + '-12';

  const { isLoading, refetch } = useQuery(
    [endpoints.master.sale.lecture.list, [location.search]],
    () =>
      fetcher.master.postMasterLecturList({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : default_start_date,   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : default_end_date,   
        lecturer: searchParams.lecturer ? String(searchParams.lecturer) : '',
        lecturer_category: searchParams.lecturer_category ? String(searchParams.lecturer_category) : '',                  
      }),
    {
      onSuccess: (res: MasterLecturResDto) => {
        switch (res.code) {
          case 200:
            setLectureList(res.result?.list);
            setSummary(res.result?.summary);
            setGap(res.result?.gap);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { lectureList, summary, gap, isLoading, refetch };
};

export default useMasterLecture;
